// extracted by mini-css-extract-plugin
export default {"container":"OtLPu","homeBtn":"Jjztj","tile":"v3o0E","btnDiv":"CGL_9","tiles-wrapper":"yFQjX"};